import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface StartNewQuestDialogData {
  title: string;
  // may hold <b> around the stage name
  message: string;
  keptText: string;
  resetText: string;
  confirmButtonText: string;
  cancelButtonText: string;
}

// Confirms "Start a New Quest": closes with true when the user confirms
@Component({
  selector: 'app-start-new-quest-dialog',
  templateUrl: './start-new-quest-dialog.component.html',
  styleUrl: './start-new-quest-dialog.component.scss'
})
export class StartNewQuestDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<StartNewQuestDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: StartNewQuestDialogData) {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
